<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="`col-12 col-md-6 col-lg-4 col-xl-4`"
              classLots="`col-12 col-md-6 col-lg-4 col-xl-4`"
            />
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12">
      <div v-if="headers">
        <card
          class="custom-shadow-card-header custom-table-responsive"
          :title="$t('sigatoka.biological_warning_report')"
          ref="tableHeaders"
        >
          <div v-if="isIndex()">
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
              class="mr-3 mt-4"
            />
            <master-table
              :infoTable="queriedData"
              :columns="tableColumns"
              :showColumnStatus="false"
            >
              <template slot="addColumnsOperations">
                <table-columns-operations
                  v-if="isShow()"
                  @handleView="handleView"
                  :showOperationEdit="false"
                  :canDelete="false"
                  :minWidth="120"
                />
              </template>
            </master-table>
          </div>
          <not-index-permissions v-else />
          <card-footer ref="cardfooter" :propPagination="pagination" />
          <!--Por si quieren exportar-->
          <!-- <export-tables
            :pdf="{
              filename: '',
              route: '',
              paramMethod: '',
              plusData: '',
            }"
            :xls="{
              filename: '',
              route: '',
              paramMethod: '',
              plusData: '',
            }"
          /> -->
        </card>
      </div>
      <div v-if="details">
        <card
          class="custom-shadow-card-header mt-4"
          :title="$t('sigatoka.biological_warning_report')"
          ref="tableDetails"
        >
          <div class="mt-4 px-3">
            <div class="row">
              <div
                class="table-responsive custom-scroll-table-wrapper mb-5 border"
              >
                <bw-table
                  :model="this.model"
                  :bw_config="this.bw_config"
                ></bw-table>
              </div>
              <div class="w-100 mb-5 d-flex justify-content-around">
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.total_last_week') }}:</strong>
                  </h6>
                  {{ total_lw }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.total_actual_week') }}:</strong>
                  </h6>
                  {{ total_aw }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.ref') }}:</strong>
                  </h6>
                  {{ ref }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.reh') }}1:</strong>
                  </h6>
                  {{ reh1 }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.reh') }}:</strong>
                  </h6>
                  {{ reh }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.rem') }}:</strong>
                  </h6>
                  {{ rem }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.gross_sum') }}:</strong>
                  </h6>
                  {{ gross_sum }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.evolutionary_status') }}:</strong>
                  </h6>
                  {{ evolutionary_stage }}
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import Filter from 'src/components/Filter/Filters.vue';
import { Pagination as LPagination } from 'src/components/index';
import MixinMenu from 'src/util/mixinMenu';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import BwTableComponent from 'src/views/Pages/Dashboard/Sigatoka/BiologicalWarningReport/components/BwTableComponent.vue';
import configTable from 'src/views/Pages/Dashboard/Sigatoka/BiologicalWarningReport/report-table.js';

export default {
  components: {
    [BwTableComponent.name]: BwTableComponent,
    [Filter.name]: Filter,
    LPagination,
  },
  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinForm],
  data() {
    return {
      ref: 0,
      reh: 0,
      rem: 0,
      reh1: 0,
      farm_id: [],
      total_lw: 0,
      total_aw: 0,
      gross_sum: 0,
      details: false,
      headers: false,
      pagination: {},
      tableColumns: [],
      valueCollapse: null,
      activeName: 'filter',
      evolutionary_stage: 0,
      bw_config: [
        {
          number: 3,
          status: [1, 2, 3],
          minus: [40, 80, 120],
          plus: [60, 100, 140],
        },
        {
          number: 4,
          status: [1, 2, 3],
          minus: [20, 60, 100],
          plus: [40, 80, 120],
        },
        {
          number: 5,
          status: [1, 2, 3, 4],
          minus: [10, 40, 80, 120],
          plus: [20, 60, 100, 140],
        },
      ],
      model: [],
    };
  },
  computed: {
    getRoute() {
      return 'sigatoka/biologicalwarning';
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleFilter(data) {
      this.showHideLoading(true);
      this.dataFilter = { ...this.dataFilter, ...data };
      this.farm_id = data.farm;
      this.headers = false;
      this.details = false;
      this.getBiologicalWarningHeaders();
    },
    async handleView(_, row) {
      this.showHideLoading(true);
      if (!this.hasConfig())
        SweetAlert.warning(i18n.t('sigatoka.error_no_sigatoka_config'));
      await this.getBiologicalWarningDetails(_, row);
      this.showHideLoading();
    },
    async hasConfig() {
      const data = {
        route: this.getRoute + '/config',
        farm_id: this.farm_id,
      };
      const configRes = await Axios.postMasters(data);
      if (!configRes || !configRes.data.data) return false;
      const config = configRes.data.data;
      this.hasBwConfig(config);

      return true;
    },
    hasBwConfig(data) {
      this.hasBw = data.config_bio_warning == 0 ? false : true;
      if (this.hasBw == true) this.setBwConfig(data);
    },
    setBwConfig(data) {
      this.bw_config = [];
      data.sigatoka_config_bws.forEach((object, index) => {
        this.bw_config.push({
          number: object.leaf,
          status: [],
          minus: [],
          plus: [],
        });
        object.sigatoka_config_bw_grosses.forEach((obj) => {
          this.bw_config[index].minus.push(obj.minus);
          this.bw_config[index].plus.push(obj.plus);
        });
        object.sigatoka_config_bw_statuses.forEach((obj) =>
          this.bw_config[index].status.push(obj.status)
        );
      });
    },
    setupTables() {
      const { Table } = configTable();
      this.pagination = { ...Table.pagination };
      this.tableColumns = Table.tableColumns;
    },
    async getBiologicalWarningHeaders() {
      const route = 'sigatoka/biologicalwarning/headers';
      const data = {
        ...this.dataFilter,
        route: route,
      };

      await Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.headers = true;
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
            this.$nextTick(() => {
              this.$refs.tableHeaders.$el.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            });
          }
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
      this.showHideLoading();
    },
    async getBiologicalWarningDetails(_, row) {
      this.details = false;
      this.rowData = row;
      const data = 'sigatoka/biologicalwarning/details/' + this.rowData.id;
      await Axios.getMasters(data)
        .then((response) => {
          this.model = response.data.data;
          this.total_lw = this.rowData.total_last_week;
          this.total_aw = this.rowData.total_actual_week;
          this.ref = this.rowData.ref;
          this.reh1 = this.rowData.reh1;
          this.reh = this.rowData.reh;
          this.rem = this.rowData.rem;
          this.gross_sum = this.rowData.gross_sum;
          this.evolutionary_stage = this.rowData.evolutionary_stage;
          this.details = true;
          this.$nextTick(() => {
            this.$refs.tableDetails.$el.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
  },
  created() {
    if (this.isIndex()) {
      this.setupTables();
    }
  },
  mounted() {
    this.selectedItemOnMenu('sigatoka');
  },
  beforeDestroy() {
    this.deselectedItemOnMenu('sigatoka');
  },
};
</script>
<style scoped>
.custom-scroll-table-wrapper {
  max-height: 600px;
  overflow: auto;
}
.custom-scroll-table-wrapper table {
  min-width: 1200px;
  border-collapse: collapse;
  overflow: auto;
}
.table-data th,
.table-data td {
  white-space: nowrap;
}
</style>
